import script from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=6da660c0&lang=scss"
import "./LanguageSwitch.vue?vue&type=style&index=1&id=6da660c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da660c0"]])

export default __exports__